import { LineDividerDropdownItem } from 'common/Prose/nodeViews/LineDivider/LineDividerDropdownItem'
import { DEFAULT_STYLE, LineStyle, LINE_STYLES } from 'common/Prose/nodeViews/LineDivider/types'
import { insertAndFocus } from 'common/Prose/utils/insertAndFocus'
import { InsertButton } from '../InsertButton/InsertButton'
import Styles from './InsertLineDividerButton.module.scss'
import { SingleMenuDropdownContext } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownStore'
import { useContext } from 'react'
import { LineDivider } from 'almanac-ui/icons/16'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'

interface Props {
  isSubmenu?: boolean
}

export const InsertLineDividerButton = ({ isSubmenu }: Props) => {
  const view = useEditorView()
  const dropdownStore = useContext(SingleMenuDropdownContext)
  const insertStyle = (style: string) => {
    insertAndFocus(view, view.state.schema.nodes.line_divider.createAndFill({ lineStyle: style }))
  }

  const onClick = (style: LineStyle) => {
    insertStyle(style)
    dropdownStore?.hardClose()
  }

  const DividerButton = ({ style }: { style: LineStyle }) => {
    return (
      <button className={Styles.dividerButton} onClick={() => onClick(style)}>
        <div className={Styles.dividerButtonIcon}>
          <LineDividerDropdownItem style={style} />
        </div>
      </button>
    )
  }

  return (
    <InsertButton
      label="Divider"
      icon={<LineDivider />}
      onClick={() => onClick(DEFAULT_STYLE)}
      inDropdown={!!dropdownStore}
      isSubmenu={isSubmenu}
    >
      <div className={Styles.dividerButtons}>
        {LINE_STYLES.map((style) => (
          <DividerButton key={style} style={style} />
        ))}
      </div>
    </InsertButton>
  )
}
